import * as XLSX from 'xlsx'
import { readStoredZipEntries, writeStoredZipEntries } from './storedZip.js'

export const PROCUREMENT_SBF_TEMPLATE_FAMILY = 'plan_based_scope_v1'
export const PROCUREMENT_SEND_OUTPUT_CLASSIFICATION = 'send-ready-not-live'
export const PROCUREMENT_TRADE_LABEL_SOURCE_FIELD = 'trade_tags'
export const PROCUREMENT_TRADE_LABEL_RESOLUTION_MODE = 'derived_from_scope_trade_tags'
export const PROCUREMENT_QTY_UOM_OPTIONS = [
  'EA',
  'SF',
  'SY',
  'LF',
  'Homesite',
  'Building',
  'Plan',
  'Other'
]
export const PROCUREMENT_BASIS_OPTIONS = [
  'LS',
  'EA',
  'SF',
  'SY',
  'LF',
  'Per Homesite',
  'Per Plan',
  'Per Building',
  'Allowance',
  'Mixed Average',
  'Other'
]
export const PROCUREMENT_YES_NO_OPTIONS = ['Yes', 'No']
export const PROCUREMENT_DELIVERY_QUARTER_OPTIONS = ['Q1', 'Q2', 'Q3', 'Q4']
export const PROCUREMENT_PRICING_SCHEDULE_INSTRUCTIONS = [
  'Use Quantity for how many.',
  'Use Unit for the main price type. Examples: EA, SF, SY, LF, LS, or Allowance.',
  'Use Qty UOM only if you need to clarify what the quantity is counting.',
  'If something is just an alternate and should not add into the main total yet, leave Quantity blank.'
].join('\n')

const PRICING_HEADER_ROW = 6
const PRICING_TOTAL_ROW = 5
const PRICING_FIRST_DATA_ROW = 7
const PRICING_LAST_DATA_ROW = 67
const PRICING_TOTAL_LABEL_COLUMN = 'D'
const PRICING_TOTAL_COLUMN = 'E'
const PRICING_SHEET_NAME = 'Pricing Schedule'
const COVER_SHEET_NAME = 'Cover Sheet'
const EXCLUSIONS_SHEET_NAME = 'Exclusions'
const LISTS_SHEET_NAME = 'Lists'
const COVER_LOGO_WIDTH_EMU = 841248
const COVER_LOGO_HEIGHT_EMU = 868679
const PRICING_LOGO_WIDTH_EMU = 640080
const PRICING_LOGO_HEIGHT_EMU = 640080
const LOGO_TOP_OFFSET_EMU = 91440
const BLUE_FILL_ARGB = 'FF5375B9'
const BLACK_BORDER_ARGB = 'FF000000'
const COVER_PRINT_AREA = `${quoteSheetName(COVER_SHEET_NAME)}!$A$1:$F$30`
const PRICING_PRINT_AREA = `${quoteSheetName(PRICING_SHEET_NAME)}!$A$1:$M$67`
const EXCLUSIONS_PRINT_AREA = `${quoteSheetName(EXCLUSIONS_SHEET_NAME)}!$A$1:$B$30`
const PROCUREMENT_VENDOR_UPLOAD_PLACEHOLDER_URL = 'https://upload.hbfa.example/procurement/submit'
const PROCUREMENT_VENDOR_UPLOAD_PLACEHOLDER_NOTE = 'Placeholder upload portal link. Use this controlled upload path for the completed SBF PDF and any supporting attachments once the portal is live.'

const PROCUREMENT_BRANDED_STYLES_XML = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
  <fonts count="2">
    <font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font>
    <font><sz val="14"/><color rgb="FFFFFFFF"/><name val="Calibri"/><family val="2"/></font>
  </fonts>
  <fills count="3">
    <fill><patternFill patternType="none"/></fill>
    <fill><patternFill patternType="gray125"/></fill>
    <fill><patternFill patternType="solid"><fgColor rgb="${BLUE_FILL_ARGB}"/><bgColor indexed="64"/></patternFill></fill>
  </fills>
  <borders count="9">
    <border><left/><right/><top/><bottom/><diagonal/></border>
    <border><left style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></left><right/><top/><bottom/><diagonal/></border>
    <border><left/><right style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></right><top/><bottom/><diagonal/></border>
    <border><left/><right/><top style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></top><bottom/><diagonal/></border>
    <border><left/><right/><top/><bottom style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></bottom><diagonal/></border>
    <border><left style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></left><right/><top style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></top><bottom/><diagonal/></border>
    <border><left/><right style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></right><top style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></top><bottom/><diagonal/></border>
    <border><left style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></left><right/><top/><bottom style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></bottom><diagonal/></border>
    <border><left/><right style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></right><top/><bottom style="thin"><color rgb="${BLACK_BORDER_ARGB}"/></bottom><diagonal/></border>
  </borders>
  <cellStyleXfs count="1">
    <xf numFmtId="0" fontId="0" fillId="0" borderId="0"/>
  </cellStyleXfs>
  <cellXfs count="13">
    <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>
    <xf numFmtId="0" fontId="0" fillId="2" borderId="0" xfId="0" applyFill="1"/>
    <xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="2" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="3" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="4" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="5" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="6" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="7" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="8" xfId="0" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="2" borderId="1" xfId="0" applyFill="1" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="2" borderId="2" xfId="0" applyFill="1" applyBorder="1"/>
  </cellXfs>
  <cellStyles count="1">
    <cellStyle name="Normal" xfId="0" builtinId="0"/>
  </cellStyles>
  <dxfs count="0"/>
  <tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>
</styleSheet>`

const xmlEncoder = new TextEncoder()
const xmlDecoder = new TextDecoder()

function normalizeOptionalString(value) {
  return String(value || '').trim()
}

function slugifyToken(value, fallback = '') {
  return normalizeOptionalString(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || fallback
}

function normalizeDateToken(value) {
  const normalized = normalizeOptionalString(value)
  if (!normalized) {
    return 'undated'
  }

  const isoDateMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoDateMatch) {
    return `${isoDateMatch[1]}${isoDateMatch[2]}${isoDateMatch[3]}`
  }

  return normalized.replace(/[^0-9]/g, '').slice(0, 8) || 'undated'
}

function uniqueOrdered(values) {
  const result = []
  const seen = new Set()

  for (const value of values || []) {
    const normalized = normalizeOptionalString(value)
    const dedupeKey = normalized.toLowerCase()
    if (!normalized || seen.has(dedupeKey)) {
      continue
    }

    seen.add(dedupeKey)
    result.push(normalized)
  }

  return result
}

function uniqueSorted(values) {
  return Array.from(new Set((values || []).map(normalizeOptionalString).filter(Boolean)))
    .sort((left, right) => left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base' }))
}

function normalizeNumber(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

function quoteSheetName(name) {
  return `'${String(name || '').replace(/'/g, "''")}'`
}

function escapeRegExp(value) {
  return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function formatList(values) {
  const items = uniqueSorted(values)
  return items.length ? items.join(', ') : '--'
}

function formatLinkList(values) {
  const items = uniqueSorted(values)
  return items.length ? items.join('\n') : '--'
}

function formatEmailList(values) {
  return uniqueSorted(values).join('; ')
}

function formatBodyList(values) {
  const items = uniqueSorted(values)
  return items.length ? items.map((item) => `- ${item}`).join('\n') : '- None provided.'
}

function formatCountNoun(count, singular, plural = `${singular}s`) {
  const normalized = Number(count)
  const safeCount = Number.isFinite(normalized) ? normalized : 0
  return `${safeCount} ${safeCount === 1 ? singular : plural}`
}

function joinWithAnd(values) {
  const items = uniqueSorted(values)
  if (items.length <= 1) {
    return items[0] || ''
  }
  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`
  }

  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`
}

function normalizeStoryLabel(value) {
  const normalized = normalizeOptionalString(value)
  if (!normalized) {
    return ''
  }

  if (/story/i.test(normalized)) {
    return normalized.replace(/\s+/g, ' ')
  }

  const parsedNumber = Number(normalized)
  if (Number.isFinite(parsedNumber)) {
    return `${parsedNumber} story`
  }

  return normalized
}

function buildStoryMix(units) {
  return joinWithAnd((units || []).map((unit) => normalizeStoryLabel(unit?.stories)))
}

function parseProjectAddress(address) {
  const normalized = normalizeOptionalString(address)
  if (!normalized) {
    return { city: '', state: '' }
  }

  const match = normalized.match(/,\s*([^,]+?)\s+([A-Z]{2})(?:\s+\d{5}(?:-\d{4})?)?$/)
  if (!match) {
    return { city: '', state: '' }
  }

  return {
    city: normalizeOptionalString(match[1]),
    state: normalizeOptionalString(match[2])
  }
}

function buildCityStateLabel(city, state) {
  const normalizedCity = normalizeOptionalString(city)
  const normalizedState = normalizeOptionalString(state)

  if (normalizedCity && normalizedState) {
    return `${normalizedCity}, ${normalizedState}`
  }

  return normalizedCity || normalizedState || ''
}

function buildDeliverySummary(packageContext) {
  const override = normalizeOptionalString(packageContext?.delivery_summary_override)
  if (override) {
    return override
  }

  const quarter = normalizeOptionalString(packageContext?.delivery_start_quarter)
  const year = normalizeOptionalString(packageContext?.delivery_start_year)
  if (quarter && year) {
    return `${quarter} ${year}`
  }

  return quarter || year || ''
}

function buildProjectDisplayLabel(project) {
  const projectName = normalizeOptionalString(project?.project_name)
  const projectId = normalizeOptionalString(project?.project_id)

  if (projectName && projectId && projectName !== projectId) {
    return `${projectName} (${projectId})`
  }

  return projectName || projectId || 'Project TBD'
}

function buildOutlookComposeUrl({ to, subject, body }) {
  const base = 'https://outlook.office.com/mail/deeplink/compose'
  const recipients = formatEmailList(to)
  const params = []

  if (recipients) {
    params.push(`to=${encodeURIComponent(recipients)}`)
  }

  params.push(`subject=${encodeURIComponent(normalizeOptionalString(subject))}`)
  params.push(`body=${encodeURIComponent(normalizeOptionalString(body))}`)
  return `${base}?${params.join('&')}`
}

function buildRfpPackageName(rfpModel) {
  const projectLabel = buildProjectDisplayLabel(rfpModel?.project)
  const scopeName = normalizeOptionalString(rfpModel?.scope?.scope_name)
    || normalizeOptionalString(rfpModel?.scope?.scope_id)
    || 'Scope TBD'

  return `${projectLabel} - ${scopeName} Bid Package`
}

function buildMinimumVendorBidsPerScope(vendors) {
  const selectedVendorCount = Array.isArray(vendors) ? vendors.length : 0
  return selectedVendorCount > 0 ? selectedVendorCount : null
}

function mergeBidPackageIntakeTargets(existingTargets, draftTargets) {
  const requestedVendorIds = uniqueSorted([
    ...(existingTargets?.requested_vendor_ids || []),
    ...(draftTargets?.requested_vendor_ids || [])
  ])
  const existingMinimum = Number.isInteger(existingTargets?.minimum_vendor_bids_per_scope)
    ? existingTargets.minimum_vendor_bids_per_scope
    : null
  const draftMinimum = Number.isInteger(draftTargets?.minimum_vendor_bids_per_scope)
    ? draftTargets.minimum_vendor_bids_per_scope
    : null
  const minimumVendorBidsPerScope = existingMinimum ?? draftMinimum

  if (!requestedVendorIds.length && minimumVendorBidsPerScope === null) {
    return null
  }

  return {
    requested_vendor_ids: requestedVendorIds,
    minimum_vendor_bids_per_scope: minimumVendorBidsPerScope
  }
}

export function buildRfpPackageId(rfpModel) {
  const projectToken = slugifyToken(rfpModel?.project?.project_id, 'project')
  const scopeToken = slugifyToken(rfpModel?.scope?.scope_id, 'scope')
  const dueDateToken = normalizeDateToken(rfpModel?.package_context?.due_at)

  return `pkg_${projectToken}_${scopeToken}_${dueDateToken}`
}

export function buildRfpPackageWritePayload(rfpModel) {
  const selectedVendorIds = uniqueSorted((rfpModel?.vendors || []).map((vendor) => vendor?.vendor_id))
  const minimumVendorBidsPerScope = buildMinimumVendorBidsPerScope(rfpModel?.vendors)

  return {
    package_id: buildRfpPackageId(rfpModel),
    project_id: normalizeOptionalString(rfpModel?.project?.project_id),
    phase_id: '',
    package_name: buildRfpPackageName(rfpModel),
    community_name: normalizeOptionalString(rfpModel?.project?.project_name)
      || normalizeOptionalString(rfpModel?.project?.project_id),
    product_type: normalizeOptionalString(rfpModel?.package_context?.home_type_label),
    plan_types: uniqueSorted(rfpModel?.project?.included_plan_types),
    scope_ids: [normalizeOptionalString(rfpModel?.scope?.scope_id)].filter(Boolean),
    status: 'draft',
    issued_at: '',
    due_at: normalizeOptionalString(rfpModel?.package_context?.due_at),
    created_by: '',
    notes: '',
    intake_targets: selectedVendorIds.length || minimumVendorBidsPerScope !== null
      ? {
        requested_vendor_ids: selectedVendorIds,
        minimum_vendor_bids_per_scope: minimumVendorBidsPerScope
      }
      : null,
    quantity_driver_snapshot: null
  }
}

export function buildIssuedRfpPackageWritePayload(packageDraft, options = {}) {
  const existingPackage = options.existingPackage || null
  const issuedAt = normalizeOptionalString(options.issuedAt)
    || normalizeOptionalString(existingPackage?.issued_at)
  const createdBy = normalizeOptionalString(existingPackage?.created_by)
    || normalizeOptionalString(options.createdBy)
    || normalizeOptionalString(packageDraft?.created_by)

  return {
    package_id: normalizeOptionalString(existingPackage?.package_id)
      || normalizeOptionalString(packageDraft?.package_id),
    project_id: normalizeOptionalString(existingPackage?.project_id)
      || normalizeOptionalString(packageDraft?.project_id),
    phase_id: normalizeOptionalString(existingPackage?.phase_id)
      || normalizeOptionalString(packageDraft?.phase_id),
    package_name: normalizeOptionalString(existingPackage?.package_name)
      || normalizeOptionalString(packageDraft?.package_name),
    community_name: normalizeOptionalString(existingPackage?.community_name)
      || normalizeOptionalString(packageDraft?.community_name),
    product_type: normalizeOptionalString(existingPackage?.product_type)
      || normalizeOptionalString(packageDraft?.product_type),
    plan_types: Array.isArray(existingPackage?.plan_types) && existingPackage.plan_types.length
      ? existingPackage.plan_types
      : uniqueSorted(packageDraft?.plan_types),
    scope_ids: Array.isArray(existingPackage?.scope_ids) && existingPackage.scope_ids.length
      ? existingPackage.scope_ids
      : uniqueSorted(packageDraft?.scope_ids),
    status: 'issued',
    issued_at: issuedAt,
    due_at: normalizeOptionalString(existingPackage?.due_at)
      || normalizeOptionalString(packageDraft?.due_at),
    created_by: createdBy,
    notes: normalizeOptionalString(existingPackage?.notes)
      || normalizeOptionalString(packageDraft?.notes),
    intake_targets: mergeBidPackageIntakeTargets(
      existingPackage?.intake_targets,
      packageDraft?.intake_targets
    ),
    quantity_driver_snapshot: existingPackage?.quantity_driver_snapshot
      || packageDraft?.quantity_driver_snapshot
      || null
  }
}

export function buildVendorPortalSubmissionId({ packageId, vendorId }) {
  return `portal_sub_${slugifyToken(packageId, 'package')}_${slugifyToken(vendorId, 'vendor')}`
}

export function buildIssuedSbfArtifactId({ packageId, vendorId }) {
  return `sbf_art_${slugifyToken(packageId, 'package')}_${slugifyToken(vendorId, 'vendor')}`
}

export function buildVendorPortalAccess(portalPreparation) {
  return {
    package_id: normalizeOptionalString(portalPreparation?.package_id),
    vendor_id: normalizeOptionalString(portalPreparation?.vendor_id),
    portal_submission_id: normalizeOptionalString(portalPreparation?.portal_submission_id),
    sbf_artifact_id: normalizeOptionalString(portalPreparation?.sbf_artifact_id)
  }
}

export function buildVendorPortalUrl(portalAccess, options = {}) {
  const baseUrl = normalizeOptionalString(options.baseUrl)
  if (!baseUrl) {
    return ''
  }

  const url = new URL(baseUrl)

  for (const [key, value] of Object.entries(buildVendorPortalAccess(portalAccess))) {
    const normalized = normalizeOptionalString(value)
    if (!normalized) {
      continue
    }

    url.searchParams.set(key, normalized)
  }

  return url.toString()
}

function buildVendorInvitationParagraph(rfpModel) {
  const tradeRequest = normalizeOptionalString(rfpModel?.scope?.trade_label)
    || joinWithAnd(rfpModel?.scope?.trade_tags)
    || normalizeOptionalString(rfpModel?.scope?.scope_name)
    || 'this scope'
  const projectLabel = buildProjectDisplayLabel(rfpModel?.project)
  const locationLabel = buildCityStateLabel(rfpModel?.project?.project_city, rfpModel?.project?.project_state)
  const unitCountText = formatCountNoun(rfpModel?.project?.unit_count, 'unit')
  const homeTypeLabel = normalizeOptionalString(rfpModel?.package_context?.home_type_label)
  const buildingCountText = formatCountNoun(rfpModel?.project?.building_count, 'building')
  const storyMix = normalizeOptionalString(rfpModel?.project?.story_mix)
  const deliverySummary = buildDeliverySummary(rfpModel?.package_context)
  const opening = [
    `You are invited to bid ${tradeRequest} on Homes Built For America's newest project ${projectLabel}`,
    locationLabel ? `in ${locationLabel}` : null
  ].filter(Boolean).join(' ')

  let paragraph = `${opening}. This community includes ${unitCountText}${homeTypeLabel ? ` ${homeTypeLabel}` : ''} across ${buildingCountText}`

  if (storyMix) {
    paragraph += `, with ${storyMix} construction`
  }

  if (deliverySummary) {
    paragraph += `, and expected deliveries beginning in ${deliverySummary}`
  }

  paragraph += '.'
  return paragraph
}

function padRows(rows, columnCount, rowCount) {
  const normalizedRows = rows.map((row) => {
    const nextRow = Array.isArray(row) ? row.slice(0, columnCount) : []
    while (nextRow.length < columnCount) {
      nextRow.push('')
    }
    return nextRow
  })

  while (normalizedRows.length < rowCount) {
    normalizedRows.push(Array(columnCount).fill(''))
  }

  return normalizedRows
}

function buildPricingValidationMarkup() {
  return `<dataValidations count="2"><dataValidation sqref="C${PRICING_FIRST_DATA_ROW}:C${PRICING_LAST_DATA_ROW}" allowBlank="1" type="list"><formula1>=basis_options</formula1></dataValidation><dataValidation sqref="F${PRICING_FIRST_DATA_ROW}:F${PRICING_LAST_DATA_ROW}" allowBlank="1" type="list"><formula1>=qty_uom_options</formula1></dataValidation></dataValidations>`
}

function buildPlanTypeCountMap(planRows) {
  return new Map((planRows || [])
    .map((row) => [
      normalizeOptionalString(row?.plan_type),
      Number.isFinite(Number(row?.included_unit_count)) ? Number(row.included_unit_count) : 0
    ])
    .filter(([planType]) => planType))
}

function buildBuildingCountMap(buildingIds) {
  return new Map(uniqueSorted(buildingIds).map((buildingId) => [buildingId, 1]))
}

function buildContactSummary(vendor) {
  const contacts = Array.isArray(vendor?.contacts) ? vendor.contacts : []
  const parts = contacts
    .map((contact) => {
      const name = normalizeOptionalString(contact?.name)
      const email = normalizeOptionalString(contact?.email)
      const phones = [
        normalizeOptionalString(contact?.office_phone),
        normalizeOptionalString(contact?.cell_phone)
      ].filter(Boolean)

      return [name || null, email || null, phones.length ? phones.join(' / ') : null]
        .filter(Boolean)
        .join(' | ')
    })
    .filter(Boolean)

  return parts.length ? parts.join('\n') : '--'
}

export function collectVendorEmails(vendor) {
  const contacts = Array.isArray(vendor?.contacts) ? vendor.contacts : []
  return uniqueSorted(contacts.map((contact) => contact?.email))
}

function normalizeScopeTradeTags(scope) {
  const tradeTags = Array.isArray(scope?.trade_tags)
    ? scope.trade_tags
    : String(scope?.trade_tags || '')
      .split('|')
      .map((value) => value.trim())
      .filter(Boolean)

  return uniqueSorted(tradeTags)
}

export function buildScopeTradeLabelContract(scope, selectedTradeLabel = '') {
  const tradeLabelOptions = normalizeScopeTradeTags(scope)
  const fallbackTradeLabel = normalizeOptionalString(scope?.scope_name)
  const resolvedTradeLabel = normalizeOptionalString(selectedTradeLabel)
  const normalizedTradeLabelOptions = tradeLabelOptions.length
    ? tradeLabelOptions
    : [fallbackTradeLabel].filter(Boolean)

  return {
    source_field: PROCUREMENT_TRADE_LABEL_SOURCE_FIELD,
    resolution_mode: PROCUREMENT_TRADE_LABEL_RESOLUTION_MODE,
    normalized_field_present: false,
    trade_label_options: normalizedTradeLabelOptions,
    resolved_trade_label: resolvedTradeLabel || normalizedTradeLabelOptions[0] || ''
  }
}

export function buildScopeTradeLabelOptions(scope) {
  return buildScopeTradeLabelContract(scope).trade_label_options
}

export function buildVendorSearchTermsForScope(scope, selectedTradeLabel = '') {
  const tradeLabelContract = buildScopeTradeLabelContract(scope, selectedTradeLabel)

  return uniqueOrdered([
    tradeLabelContract.resolved_trade_label,
    normalizeOptionalString(scope?.scope_id)
  ])
}

export function buildProjectOptions(units) {
  const projectMap = new Map()

  for (const unit of units || []) {
    const projectId = normalizeOptionalString(unit?.project_id)
    if (!projectId) {
      continue
    }

    const current = projectMap.get(projectId) || {
      project_id: projectId,
      unit_rows: [],
      buildings: new Set(),
      plan_types: new Set(),
      addresses: new Set(),
      states: new Set()
    }

    current.unit_rows.push(unit)

    const buildingId = normalizeOptionalString(unit?.building_id)
    if (buildingId) {
      current.buildings.add(buildingId)
    }

    const planType = normalizeOptionalString(unit?.plan_type)
    if (planType) {
      current.plan_types.add(planType)
    }

    const address = normalizeOptionalString(unit?.address)
    if (address) {
      current.addresses.add(address)
    }

    const state = normalizeOptionalString(unit?.state)
    if (state) {
      current.states.add(state)
    }

    projectMap.set(projectId, current)
  }

  return Array.from(projectMap.values())
    .map((project) => {
      const projectAddress = project.addresses.size === 1 ? Array.from(project.addresses)[0] : ''
      const parsedAddress = parseProjectAddress(projectAddress)

      return {
        project_id: project.project_id,
        project_name: project.project_id,
        project_address: projectAddress,
        project_city: parsedAddress.city,
        project_state: parsedAddress.state || (project.states.size === 1 ? Array.from(project.states)[0] : ''),
        unit_count: project.unit_rows.length,
        building_count: project.buildings.size,
        plan_count: project.plan_types.size,
        buildings: uniqueSorted(Array.from(project.buildings)),
        plan_types: uniqueSorted(Array.from(project.plan_types)),
        unit_rows: project.unit_rows.slice().sort((left, right) => {
        const leftSequence = normalizeNumber(left?.sequence) ?? Number.MAX_SAFE_INTEGER
        const rightSequence = normalizeNumber(right?.sequence) ?? Number.MAX_SAFE_INTEGER
        if (leftSequence !== rightSequence) {
          return leftSequence - rightSequence
        }

        return normalizeOptionalString(left?.unit_number).localeCompare(
          normalizeOptionalString(right?.unit_number),
          undefined,
          { numeric: true, sensitivity: 'base' }
        )
        })
      }
    })
    .sort((left, right) => left.project_id.localeCompare(right.project_id, undefined, { numeric: true, sensitivity: 'base' }))
}

export function buildVendorOption(vendor) {
  return {
    vendor_id: normalizeOptionalString(vendor?.vendor_id),
    company_name: normalizeOptionalString(vendor?.company_name),
    trade: normalizeOptionalString(vendor?.trade),
    status: normalizeOptionalString(vendor?.status) || 'active',
    scope_ids: uniqueSorted(Array.isArray(vendor?.scope_ids) ? vendor.scope_ids : []),
    scopes: uniqueSorted(Array.isArray(vendor?.scopes) ? vendor.scopes : []),
    contacts: Array.isArray(vendor?.contacts) ? vendor.contacts : [],
    resolved_emails: uniqueSorted(Array.isArray(vendor?.resolved_emails) ? vendor.resolved_emails : collectVendorEmails(vendor)),
    contact_summary: normalizeOptionalString(vendor?.contact_summary) || buildContactSummary(vendor)
  }
}

function buildPlanRows(includedUnits, scope) {
  const planMap = new Map()

  for (const unit of includedUnits) {
    const planType = normalizeOptionalString(unit?.plan_type) || 'Unspecified Plan'
    const current = planMap.get(planType) || {
      line_key: planType.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''),
      plan_type: planType,
      scope_name: normalizeOptionalString(scope?.scope_name),
      included_unit_count: 0,
      included_building_count: 0,
      plan_sf: null,
      included_buildings: new Set(),
      included_unit_numbers: []
    }

    current.included_unit_count += 1

    const buildingId = normalizeOptionalString(unit?.building_id)
    if (buildingId) {
      current.included_buildings.add(buildingId)
    }

    const unitNumber = normalizeOptionalString(unit?.unit_number)
    if (unitNumber) {
      current.included_unit_numbers.push(unitNumber)
    }

    if (current.plan_sf === null) {
      current.plan_sf = normalizeNumber(unit?.plan_sf)
    }

    planMap.set(planType, current)
  }

  return Array.from(planMap.values())
    .map((row) => {
      const includedBuildings = uniqueSorted(Array.from(row.included_buildings))
      const includedUnitNumbers = uniqueSorted(row.included_unit_numbers)
      return {
        line_key: row.line_key || row.plan_type,
        scope_name: row.scope_name,
        plan_type: row.plan_type,
        line_label: row.plan_type,
        description: `${row.plan_type} pricing row`,
        included_unit_count: row.included_unit_count,
        included_building_count: includedBuildings.length,
        plan_sf: row.plan_sf,
        included_buildings: includedBuildings,
        included_unit_numbers: includedUnitNumbers
      }
    })
    .sort((left, right) => left.plan_type.localeCompare(right.plan_type, undefined, { numeric: true, sensitivity: 'base' }))
}

function buildIncludedUnits(project, buildingExclusions, unitExclusions) {
  const excludedBuildings = new Set(uniqueSorted(buildingExclusions))
  const excludedUnits = new Set(uniqueSorted(unitExclusions))

  return (project?.unit_rows || []).filter((unit) => {
    const buildingId = normalizeOptionalString(unit?.building_id)
    const unitNumber = normalizeOptionalString(unit?.unit_number)
    if (excludedBuildings.has(buildingId)) {
      return false
    }
    if (excludedUnits.has(unitNumber)) {
      return false
    }
    return true
  })
}

function buildCompletedSbfPdfFilename(vendorPortalPreparation) {
  return buildPlanBasedSbfFilename({
    projectId: vendorPortalPreparation?.project_id,
    scopeId: vendorPortalPreparation?.scope_id,
    vendorId: vendorPortalPreparation?.vendor_id
  }).replace(/\.xlsx$/i, '.pdf')
}

function buildVendorPortalAttachmentBaseName(vendor) {
  return (
    normalizeOptionalString(vendor?.company_name)
      || normalizeOptionalString(vendor?.vendor_id)
      || 'Vendor'
  )
    .replace(/[^A-Za-z0-9._-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
}

function buildVendorPortalSupportingAttachments(vendor) {
  const baseName = buildVendorPortalAttachmentBaseName(vendor)

  return [
    {
      attachment_role: 'original_proposal',
      sequence: 1,
      file_name: `${baseName}-Original-Proposal.pdf`,
      artifact_type: 'pdf',
      content_type: 'application/pdf'
    },
    {
      attachment_role: 'cover_letter',
      sequence: 1,
      file_name: `${baseName}-Cover-Letter.pdf`,
      artifact_type: 'pdf',
      content_type: 'application/pdf'
    },
    {
      attachment_role: 'supporting_attachment_1',
      sequence: 1,
      file_name: `${baseName}-Supporting-Attachment-1.pdf`,
      artifact_type: 'pdf',
      content_type: 'application/pdf'
    },
    {
      attachment_role: 'supporting_attachment_2',
      sequence: 1,
      file_name: `${baseName}-Supporting-Attachment-2.pdf`,
      artifact_type: 'pdf',
      content_type: 'application/pdf'
    }
  ]
}

export function buildVendorPortalPreparation(rfpModel, vendor) {
  const packageDraft = buildRfpPackageWritePayload(rfpModel)
  const vendorId = normalizeOptionalString(vendor?.vendor_id)

  const portalPreparation = {
    package_id: packageDraft.package_id,
    package_name: packageDraft.package_name,
    project_id: normalizeOptionalString(rfpModel?.project?.project_id),
    scope_id: normalizeOptionalString(rfpModel?.scope?.scope_id),
    scope_ids: uniqueSorted(packageDraft.scope_ids),
    vendor_id: vendorId,
    portal_submission_id: buildVendorPortalSubmissionId({
      packageId: packageDraft.package_id,
      vendorId
    }),
    sbf_artifact_id: buildIssuedSbfArtifactId({
      packageId: packageDraft.package_id,
      vendorId
    })
  }

  return {
    ...portalPreparation,
    completed_sbf: {
      file_name: buildCompletedSbfPdfFilename(portalPreparation),
      artifact_type: 'pdf',
      content_type: 'application/pdf'
    },
    attachments: buildVendorPortalSupportingAttachments(vendor),
    portal_access: buildVendorPortalAccess(portalPreparation)
  }
}

export function buildVendorDraftEmail(rfpModel, vendor, options = {}) {
  const recipients = uniqueSorted(vendor?.resolved_emails)
  const companyName = normalizeOptionalString(vendor?.company_name) || normalizeOptionalString(vendor?.vendor_id) || 'Vendor'
  const projectLabel = buildProjectDisplayLabel(rfpModel?.project)
  const scopeName = normalizeOptionalString(rfpModel?.scope?.scope_name) || normalizeOptionalString(rfpModel?.scope?.scope_id) || 'Scope TBD'
  const scopeId = normalizeOptionalString(rfpModel?.scope?.scope_id)
  const tradeLabel = normalizeOptionalString(rfpModel?.scope?.trade_label)
  const tradeTags = uniqueSorted(rfpModel?.scope?.trade_tags)
  const projectAddress = normalizeOptionalString(rfpModel?.project?.project_address)
  const dueAt = normalizeOptionalString(rfpModel?.package_context?.due_at) || 'TBD'
  const scopeSummary = normalizeOptionalString(rfpModel?.package_context?.scope_summary) || 'No scope summary provided.'
  const scopeDetail = normalizeOptionalString(rfpModel?.package_context?.scope_detail)
  const rfpNotes = normalizeOptionalString(rfpModel?.package_context?.rfp_notes)
  const deliverySummary = buildDeliverySummary(rfpModel?.package_context)
  const portalUrl = normalizeOptionalString(options.portalUrl)
  const subject = `HBFA Bid Request - ${projectLabel} - ${scopeName} - ${companyName}`
  const bodyLines = [
    `Hello ${companyName},`,
    '',
    buildVendorInvitationParagraph(rfpModel),
    '',
    `Project: ${projectLabel}`,
    projectAddress ? `Project Address: ${projectAddress}` : 'Project Address: --',
    rfpModel?.project?.project_city ? `Project City: ${rfpModel.project.project_city}` : 'Project City: --',
    rfpModel?.project?.project_state ? `Project State: ${rfpModel.project.project_state}` : 'Project State: --',
    `Community Summary: ${formatCountNoun(rfpModel?.project?.unit_count, 'unit')}${rfpModel?.package_context?.home_type_label ? ` | ${rfpModel.package_context.home_type_label}` : ''} | ${formatCountNoun(rfpModel?.project?.building_count, 'building')}${rfpModel?.project?.story_mix ? ` | ${rfpModel.project.story_mix}` : ''}`,
    deliverySummary ? `Expected Deliveries: ${deliverySummary}` : 'Expected Deliveries: --',
    `Scope: ${scopeName}${scopeId ? ` (${scopeId})` : ''}`,
    tradeLabel ? `Vendor-facing Trade Label: ${tradeLabel}` : 'Vendor-facing Trade Label: --',
    tradeTags.length ? `Scope Tags: ${tradeTags.join(', ')}` : 'Scope Tags: --',
    `Bid Due Date: ${dueAt}`,
    '',
    'Scope Summary:',
    scopeSummary
  ]

  if (scopeDetail) {
    bodyLines.push('', 'Scope Detail:', scopeDetail)
  }

  bodyLines.push(
    '',
    'Box Links:',
    formatBodyList(rfpModel?.package_context?.box_links),
    '',
    'Plan Links:',
    formatBodyList(rfpModel?.package_context?.plan_links)
  )

  if (rfpNotes) {
    bodyLines.push('', 'RFP Notes:', rfpNotes)
  }

  bodyLines.push(
    '',
    'Attachment And Return Instructions:',
    '- Complete the attached Standardized Bid Form (SBF) workbook, export it to PDF, and return the PDF as the official submission file. Please save the file for your records.',
    ''
  )

  if (portalUrl) {
    bodyLines.push(
      '- Push Here To Upload Your Bid Return:',
      portalUrl,
      '- Use this controlled upload path for the completed SBF PDF and any supporting attachments.'
    )
  } else {
    bodyLines.push(
      `- Upload placeholder: ${PROCUREMENT_VENDOR_UPLOAD_PLACEHOLDER_URL}`,
      '- Use this controlled upload path for the completed SBF PDF and any supporting attachments.'
    )
  }

  bodyLines.push(
    '',
    'Thank you,',
    'HBFA Procurement'
  )

  const body = bodyLines.join('\n')

  return {
    classification: PROCUREMENT_SEND_OUTPUT_CLASSIFICATION,
    to: recipients,
    subject,
    body,
    outlook_compose_url: buildOutlookComposeUrl({
      to: recipients,
      subject,
      body
    })
  }
}

function buildSendGroups(vendors, rfpModel) {
  return (vendors || []).map((vendor) => {
    const portalPreparation = buildVendorPortalPreparation(rfpModel, vendor)

    return {
      vendor_id: vendor.vendor_id,
      company_name: vendor.company_name,
      resolved_emails: vendor.resolved_emails,
      contact_summary: vendor.contact_summary,
      portal_preparation: portalPreparation,
      draft_email: buildVendorDraftEmail(rfpModel, vendor)
    }
  })
}

function buildProjectContext(project, overrides, includedUnits) {
  const derivedAddress = normalizeOptionalString(overrides?.project_address_override)
    || normalizeOptionalString(project?.project_address)
  const parsedAddress = parseProjectAddress(derivedAddress)

  const includedBuildings = uniqueSorted(includedUnits.map((unit) => unit?.building_id))
  const includedPlans = uniqueSorted(includedUnits.map((unit) => unit?.plan_type))
  const includedStates = uniqueSorted(includedUnits.map((unit) => unit?.state))
  const storyMix = buildStoryMix(includedUnits)

  return {
    project_id: normalizeOptionalString(project?.project_id),
    project_name: normalizeOptionalString(overrides?.project_name_override) || normalizeOptionalString(project?.project_name) || normalizeOptionalString(project?.project_id),
    project_address: derivedAddress,
    project_city: parsedAddress.city || normalizeOptionalString(project?.project_city),
    project_state: parsedAddress.state || includedStates[0] || normalizeOptionalString(project?.project_state),
    unit_count: includedUnits.length,
    building_count: includedBuildings.length,
    plan_count: includedPlans.length,
    included_buildings: includedBuildings,
    included_plan_types: includedPlans,
    story_mix: storyMix
  }
}

function buildPackageContext(input) {
  return {
    due_at: normalizeOptionalString(input?.dueAt),
    scope_summary: normalizeOptionalString(input?.scopeSummary),
    scope_detail: normalizeOptionalString(input?.scopeDetail),
    home_type_label: normalizeOptionalString(input?.homeTypeLabel),
    delivery_start_quarter: normalizeOptionalString(input?.deliveryStartQuarter),
    delivery_start_year: normalizeOptionalString(input?.deliveryStartYear),
    delivery_summary_override: normalizeOptionalString(input?.deliverySummaryOverride),
    box_links: uniqueSorted(input?.boxLinks),
    plan_links: uniqueSorted(input?.planLinks),
    rfp_notes: normalizeOptionalString(input?.rfpNotes),
    building_exclusions: uniqueSorted(input?.buildingExclusions),
    unit_exclusions: uniqueSorted(input?.unitExclusions)
  }
}

export function buildRfpDraftModel({
  allUnits,
  canonicalScopeOptions,
  vendors,
  projectId,
  scopeId,
  selectedTradeLabel,
  selectedVendorIds,
  dueAt,
  buildingExclusions,
  unitExclusions,
  scopeSummary,
  scopeDetail,
  homeTypeLabel,
  deliveryStartQuarter,
  deliveryStartYear,
  deliverySummaryOverride,
  boxLinks,
  planLinks,
  rfpNotes,
  projectNameOverride,
  projectAddressOverride
}) {
  const projectOptions = buildProjectOptions(allUnits)
  const project = projectOptions.find((item) => item.project_id === normalizeOptionalString(projectId)) || null
  const scope = (canonicalScopeOptions || []).find((item) => item.scope_id === normalizeOptionalString(scopeId)) || null
  const vendorOptions = (vendors || []).map(buildVendorOption)
  const selectedVendorIdSet = new Set(uniqueSorted(selectedVendorIds))
  const selectedVendors = vendorOptions.filter((vendor) => selectedVendorIdSet.has(vendor.vendor_id))

  const includedUnits = buildIncludedUnits(project, buildingExclusions, unitExclusions)
  const projectContext = buildProjectContext(project, {
    project_name_override: projectNameOverride,
    project_address_override: projectAddressOverride
  }, includedUnits)
  const tradeLabelContract = buildScopeTradeLabelContract(scope, selectedTradeLabel)
  const packageContext = buildPackageContext({
    dueAt,
    scopeSummary,
    scopeDetail,
    homeTypeLabel,
    deliveryStartQuarter,
    deliveryStartYear,
    deliverySummaryOverride,
    boxLinks,
    planLinks,
    rfpNotes,
    buildingExclusions,
    unitExclusions
  })
  const planRows = buildPlanRows(includedUnits, scope)

  const draftModel = {
    template_family: PROCUREMENT_SBF_TEMPLATE_FAMILY,
    project: projectContext,
    project_source: project,
    scope: scope
      ? {
        scope_id: normalizeOptionalString(scope.scope_id),
        scope_name: normalizeOptionalString(scope.scope_name),
        scope_family: normalizeOptionalString(scope.scope_family),
        trade_label: tradeLabelContract.resolved_trade_label,
        trade_tags: tradeLabelContract.trade_label_options,
        trade_label_source_field: tradeLabelContract.source_field,
        trade_label_resolution_mode: tradeLabelContract.resolution_mode,
        trade_tags_normalized_present: tradeLabelContract.normalized_field_present,
        csi_code: normalizeOptionalString(scope.csi_code)
      }
      : null,
    vendors: selectedVendors,
    package_context: packageContext,
    included_units: includedUnits,
    plan_rows: planRows
  }
  const packageDraft = buildRfpPackageWritePayload(draftModel)

  return {
    ...draftModel,
    package_draft: packageDraft,
    send_groups: buildSendGroups(selectedVendors, draftModel)
  }
}

export function buildPlanBasedSbfFilename({ projectId, scopeId, vendorId }) {
  const safe = (value, fallback) => normalizeOptionalString(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || fallback

  return `${safe(projectId, 'project')}-${safe(scopeId, 'scope')}-${safe(vendorId, 'vendor')}-sbf.xlsx`
}

function createRandomHex(length) {
  const cryptoObject = globalThis.crypto
  if (cryptoObject?.getRandomValues) {
    const bytes = new Uint8Array(Math.ceil(length / 2))
    cryptoObject.getRandomValues(bytes)
    return Array.from(bytes, (value) => value.toString(16).padStart(2, '0'))
      .join('')
      .slice(0, length)
  }

  let result = ''
  while (result.length < length) {
    result += Math.floor(Math.random() * 16).toString(16)
  }

  return result.slice(0, length)
}

function createSbfArtifactId() {
  const cryptoObject = globalThis.crypto
  if (cryptoObject?.randomUUID) {
    return `sbf_${cryptoObject.randomUUID()}`
  }

  return `sbf_${createRandomHex(8)}-${createRandomHex(4)}-${createRandomHex(4)}-${createRandomHex(4)}-${createRandomHex(12)}`
}

function buildSbfWorkbookMetadata(rfpModel, vendor, options = {}) {
  return {
    artifact_id: normalizeOptionalString(options.artifactId) || createSbfArtifactId(),
    generated_at: normalizeOptionalString(options.generatedAt) || new Date().toISOString(),
    template_family: PROCUREMENT_SBF_TEMPLATE_FAMILY,
    project_id: normalizeOptionalString(rfpModel?.project?.project_id),
    scope_id: normalizeOptionalString(rfpModel?.scope?.scope_id),
    vendor_id: normalizeOptionalString(vendor?.vendor_id)
  }
}

export function buildPlanBasedSbfWorkbook(rfpModel, vendor, options = {}) {
  const workbook = XLSX.utils.book_new()
  const selectedVendor = buildVendorOption(vendor)
  const workbookMetadata = buildSbfWorkbookMetadata(rfpModel, selectedVendor, options)
  const portalUrl = normalizeOptionalString(options.portalUrl)
  const vendorUploadUrl = portalUrl || PROCUREMENT_VENDOR_UPLOAD_PLACEHOLDER_URL
  const vendorUploadNote = portalUrl
    ? 'Prepared vendor-specific upload link. Use this exact controlled return path for the completed SBF PDF and any supporting attachments.'
    : PROCUREMENT_VENDOR_UPLOAD_PLACEHOLDER_NOTE
  const returnInstructions = portalUrl
    ? 'Complete this workbook, export it to PDF, and return the PDF as the official submission artifact. Use the prepared vendor upload link above so you do not need to go back and find the email.'
    : 'Complete this workbook, export it to PDF, and return the PDF as the official submission artifact. Use the vendor upload link above for the controlled return path once it is live.'
  const coverRows = [
    ['HBFA Standardized Bid Form', ''],
    ['Template Family', PROCUREMENT_SBF_TEMPLATE_FAMILY],
    ['Generated At', workbookMetadata.generated_at],
    ['Project Name', normalizeOptionalString(rfpModel?.project?.project_name)],
    ['Project ID', normalizeOptionalString(rfpModel?.project?.project_id)],
    ['Project Address', normalizeOptionalString(rfpModel?.project?.project_address)],
    ['Scope Name', normalizeOptionalString(rfpModel?.scope?.scope_name)],
    ['Scope ID', normalizeOptionalString(rfpModel?.scope?.scope_id)],
    ['Scope Family', normalizeOptionalString(rfpModel?.scope?.scope_family)],
    ['Vendor-facing Trade Label', normalizeOptionalString(rfpModel?.scope?.trade_label)],
    ['Vendor Legal Name', normalizeOptionalString(selectedVendor.company_name)],
    ['Vendor Trade', normalizeOptionalString(selectedVendor.trade)],
    ['Vendor Contacts', selectedVendor.contact_summary],
    ['Vendor Emails', formatList(selectedVendor.resolved_emails)],
    ['Bid Due Date', normalizeOptionalString(rfpModel?.package_context?.due_at)],
    ['Scope Summary', normalizeOptionalString(rfpModel?.package_context?.scope_summary)],
    ['Box Links', formatLinkList(rfpModel?.package_context?.box_links)],
    ['Plan Links', formatLinkList(rfpModel?.package_context?.plan_links)],
    ['RFP Notes', normalizeOptionalString(rfpModel?.package_context?.rfp_notes)],
    ['Building Exclusions', formatList(rfpModel?.package_context?.building_exclusions)],
    ['Unit Exclusions', formatList(rfpModel?.package_context?.unit_exclusions)],
    ['Bid Date', ''],
    ['Validity Through', ''],
    ['Addenda Acknowledged', ''],
    ['Submitted By', ''],
    ['Submitted By Title', ''],
    ['Attachments Included', ''],
    ['Vendor Upload Link', vendorUploadUrl],
    ['Upload Portal Note', vendorUploadNote],
    ['Return Instructions', returnInstructions]
  ]

  const pricingRows = [
    ['HBFA Standardized Bid Form Pricing Schedule'],
    [`Project: ${normalizeOptionalString(rfpModel?.project?.project_name)}`],
    [`Scope: ${normalizeOptionalString(rfpModel?.scope?.scope_name)}`],
    [`Vendor: ${normalizeOptionalString(selectedVendor.company_name)}`],
    [PROCUREMENT_PRICING_SCHEDULE_INSTRUCTIONS, '', '', 'Total', '', '', '', '', '', '', '', '', ''],
    ['Description', 'Quantity', 'Unit', 'Cost/Rate', 'Total', 'Qty UOM', 'Notes', 'HBFA Plan', 'HBFA Included Unit Count', 'HBFA Included Building Count', 'HBFA Plan SF', 'HBFA Buildings', 'HBFA Unit Numbers']
  ]

  const planRows = Array.isArray(rfpModel?.plan_rows) ? rfpModel.plan_rows : []

  for (let rowIndex = 0; rowIndex <= (PRICING_LAST_DATA_ROW - PRICING_FIRST_DATA_ROW); rowIndex += 1) {
    const row = planRows[rowIndex]
    pricingRows.push([
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      row ? normalizeOptionalString(row.plan_type) : '',
      row ? row.included_unit_count : '',
      row ? row.included_building_count : '',
      row ? (row.plan_sf ?? '') : '',
      row ? row.included_buildings.join(', ') : '',
      row ? row.included_unit_numbers.join(', ') : ''
    ])
  }

  const exclusionsRows = [
    ['HBFA Standardized Bid Form Exclusions', ''],
    ['Paste large text blocks below as needed. Put Inclusions and Exclusions at the bottom. Include any extra documentation as a separate attachment upon return.', ''],
    ['Inclusions', ''],
    ['Exclusions', ''],
    ['Notes', normalizeOptionalString(rfpModel?.package_context?.rfp_notes)]
  ]

  const planTypeCountMap = buildPlanTypeCountMap(planRows)
  const buildingCountMap = buildBuildingCountMap(rfpModel?.project?.included_buildings)

  const paddedCoverRows = padRows(coverRows, 6, 30)
  const paddedPricingRows = padRows(pricingRows, 13, 67)
  const paddedExclusionsRows = padRows(exclusionsRows, 2, 30)
  const metadataRows = [
    ['sbf_artifact_id', workbookMetadata.artifact_id],
    ['sbf_generated_at', workbookMetadata.generated_at],
    ['sbf_template_family', workbookMetadata.template_family],
    ['sbf_project_id', workbookMetadata.project_id],
    ['sbf_scope_id', workbookMetadata.scope_id],
    ['sbf_vendor_id', workbookMetadata.vendor_id]
  ].filter((entry) => entry[1])

  const listsRows = [
    ['qty_uom_options', 'basis_options', 'yes_no_options', 'plan_types', 'building_ids', 'unit_numbers', 'plan_type_counts', 'building_counts', 'metadata_key', 'metadata_value'],
    [
      PROCUREMENT_QTY_UOM_OPTIONS[0],
      PROCUREMENT_BASIS_OPTIONS[0],
      PROCUREMENT_YES_NO_OPTIONS[0],
      rfpModel?.project?.included_plan_types?.[0] || '',
      rfpModel?.project?.included_buildings?.[0] || '',
      rfpModel?.included_units?.[0]?.unit_number || '',
      planTypeCountMap.get(rfpModel?.project?.included_plan_types?.[0] || '') || '',
      buildingCountMap.get(rfpModel?.project?.included_buildings?.[0] || '') || '',
      metadataRows[0]?.[0] || '',
      metadataRows[0]?.[1] || ''
    ]
  ]

  const maxListLength = Math.max(
    PROCUREMENT_QTY_UOM_OPTIONS.length,
    PROCUREMENT_BASIS_OPTIONS.length,
    PROCUREMENT_YES_NO_OPTIONS.length,
    rfpModel?.project?.included_plan_types?.length || 0,
    rfpModel?.project?.included_buildings?.length || 0,
    rfpModel?.included_units?.length || 0,
    metadataRows.length
  )

  for (let index = 1; index < maxListLength; index += 1) {
    listsRows.push([
      PROCUREMENT_QTY_UOM_OPTIONS[index] || '',
      PROCUREMENT_BASIS_OPTIONS[index] || '',
      PROCUREMENT_YES_NO_OPTIONS[index] || '',
      rfpModel?.project?.included_plan_types?.[index] || '',
      rfpModel?.project?.included_buildings?.[index] || '',
      rfpModel?.included_units?.[index]?.unit_number || '',
      planTypeCountMap.get(rfpModel?.project?.included_plan_types?.[index] || '') || '',
      buildingCountMap.get(rfpModel?.project?.included_buildings?.[index] || '') || '',
      metadataRows[index]?.[0] || '',
      metadataRows[index]?.[1] || ''
    ])
  }

  const coverSheet = XLSX.utils.aoa_to_sheet(paddedCoverRows)
  const pricingSheet = XLSX.utils.aoa_to_sheet(paddedPricingRows)
  const exclusionsSheet = XLSX.utils.aoa_to_sheet(paddedExclusionsRows)
  const listsSheet = XLSX.utils.aoa_to_sheet(listsRows)

  pricingSheet[`${PRICING_TOTAL_COLUMN}${PRICING_TOTAL_ROW}`] = {
    f: `SUM(${PRICING_TOTAL_COLUMN}${PRICING_FIRST_DATA_ROW}:${PRICING_TOTAL_COLUMN}${PRICING_LAST_DATA_ROW})`
  }

  for (let rowNumber = PRICING_FIRST_DATA_ROW; rowNumber <= PRICING_LAST_DATA_ROW; rowNumber += 1) {
    pricingSheet[`${PRICING_TOTAL_COLUMN}${rowNumber}`] = {
      f: `IF(OR(C${rowNumber}="",D${rowNumber}=""),"",IF(C${rowNumber}="Per Plan",IF(OR(B${rowNumber}="",I${rowNumber}=""),"",B${rowNumber}*D${rowNumber}*I${rowNumber}),IF(C${rowNumber}="Per Building",IF(OR(B${rowNumber}="",J${rowNumber}=""),"",B${rowNumber}*D${rowNumber}*J${rowNumber}),IF(C${rowNumber}="Per Homesite",IF(OR(B${rowNumber}="",I${rowNumber}=""),"",B${rowNumber}*D${rowNumber}*I${rowNumber}),IF(OR(C${rowNumber}="LS",C${rowNumber}="Allowance",C${rowNumber}="Mixed Average",C${rowNumber}="EA",C${rowNumber}="SF",C${rowNumber}="SY",C${rowNumber}="LF",C${rowNumber}="Other"),IF(B${rowNumber}="","",B${rowNumber}*D${rowNumber}),"")))))`
    }
  }

  coverSheet['!cols'] = [{ wch: 28 }, { wch: 90 }]
  pricingSheet['!cols'] = [
    { wch: 32 },
    { wch: 12 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 },
    { wch: 24 },
    { wch: 16 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 24 },
    { wch: 28 }
  ]
  pricingSheet['!autofilter'] = { ref: `A${PRICING_HEADER_ROW}:M${PRICING_LAST_DATA_ROW}` }
  exclusionsSheet['!cols'] = [{ wch: 36 }, { wch: 90 }]
  listsSheet['!cols'] = [
    { wch: 16 },
    { wch: 16 },
    { wch: 16 },
    { wch: 16 },
    { wch: 16 },
    { wch: 16 },
    { wch: 16 },
    { wch: 16 },
    { wch: 20 },
    { wch: 42 }
  ]

  XLSX.utils.book_append_sheet(workbook, coverSheet, COVER_SHEET_NAME)
  XLSX.utils.book_append_sheet(workbook, pricingSheet, PRICING_SHEET_NAME)
  XLSX.utils.book_append_sheet(workbook, exclusionsSheet, EXCLUSIONS_SHEET_NAME)
  XLSX.utils.book_append_sheet(workbook, listsSheet, LISTS_SHEET_NAME)
  XLSX.utils.book_set_sheet_visibility(workbook, LISTS_SHEET_NAME, 1)

  workbook.Workbook = workbook.Workbook || {}
  const workbookSheetState = Array.isArray(workbook.Workbook.Sheets) ? workbook.Workbook.Sheets : []
  workbook.Workbook.Sheets = workbook.SheetNames.map((name, index) => ({
    name,
    Hidden: workbookSheetState[index]?.Hidden || 0
  }))
  workbook.Workbook.Names = [
    { Name: 'qty_uom_options', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$A$2:$A$${Math.max(2, PROCUREMENT_QTY_UOM_OPTIONS.length + 1)}` },
    { Name: 'basis_options', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$B$2:$B$${Math.max(2, PROCUREMENT_BASIS_OPTIONS.length + 1)}` },
    { Name: 'yes_no_options', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$C$2:$C$${Math.max(2, PROCUREMENT_YES_NO_OPTIONS.length + 1)}` },
    { Name: 'plan_types', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$D$2:$D$${Math.max(2, (rfpModel?.project?.included_plan_types?.length || 0) + 1)}` },
    { Name: 'building_ids', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$E$2:$E$${Math.max(2, (rfpModel?.project?.included_buildings?.length || 0) + 1)}` },
    { Name: 'unit_numbers', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$F$2:$F$${Math.max(2, (rfpModel?.included_units?.length || 0) + 1)}` },
    { Name: 'plan_type_counts', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$G$2:$G$${Math.max(2, (rfpModel?.project?.included_plan_types?.length || 0) + 1)}` },
    { Name: 'building_counts', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$H$2:$H$${Math.max(2, (rfpModel?.project?.included_buildings?.length || 0) + 1)}` },
    { Name: 'sbf_artifact_id', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$J$2` },
    { Name: 'sbf_generated_at', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$J$3` },
    { Name: 'sbf_template_family', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$J$4` },
    { Name: 'sbf_project_id', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$J$5` },
    { Name: 'sbf_scope_id', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$J$6` },
    { Name: 'sbf_vendor_id', Ref: `${quoteSheetName(LISTS_SHEET_NAME)}!$J$7` }
  ]

  return workbook
}

function setXmlEntry(entryMap, name, content) {
  entryMap.set(name, xmlEncoder.encode(content))
}

function addOrReplaceStyleAttribute(sheetXml, cellRef, styleIndex) {
  const cellPattern = new RegExp(`<c r="${escapeRegExp(cellRef)}"([^>]*)>`)

  return sheetXml.replace(cellPattern, (match, attrs) => {
    if (/\ss="[^"]*"/.test(attrs)) {
      return `<c r="${cellRef}"${attrs.replace(/\ss="[^"]*"/, ` s="${styleIndex}"`)}>`
    }

    return `<c r="${cellRef}" s="${styleIndex}"${attrs}>`
  })
}

function insertBeforeWorksheetClose(sheetXml, markup) {
  if (sheetXml.includes(markup)) {
    return sheetXml
  }

  return sheetXml.replace('</worksheet>', `${markup}</worksheet>`)
}

function insertBeforeFirstAnchor(sheetXml, markup, anchors) {
  if (sheetXml.includes(markup)) {
    return sheetXml
  }

  for (const anchor of anchors) {
    if (sheetXml.includes(anchor)) {
      return sheetXml.replace(anchor, `${markup}${anchor}`)
    }
  }

  return insertBeforeWorksheetClose(sheetXml, markup)
}

function ensureSheetPrintSettings(sheetXml) {
  let nextXml = sheetXml

  if (!nextXml.includes('<sheetPr>')) {
    nextXml = nextXml.replace(
      /(<worksheet\b[^>]*>)/,
      '$1<sheetPr><pageSetUpPr fitToPage="1"/></sheetPr>'
    )
  } else if (!nextXml.includes('<pageSetUpPr ')) {
    nextXml = nextXml.replace('<sheetPr>', '<sheetPr><pageSetUpPr fitToPage="1"/>')
  } else {
    nextXml = nextXml.replace(/<pageSetUpPr\b[^>]*\/>/, '<pageSetUpPr fitToPage="1"/>')
  }

  const pageLayoutMarkup = '<pageMargins left="0.25" right="0.25" top="0.3" bottom="0.3" header="0.2" footer="0.2"/><pageSetup orientation="landscape" paperSize="1" fitToWidth="1" fitToHeight="0"/>'
  if (nextXml.includes('<pageMargins ')) {
    nextXml = nextXml.replace(/<pageMargins\b[^>]*\/>(?:<pageSetup\b[^>]*\/>)?/, pageLayoutMarkup)
  } else if (nextXml.includes('<ignoredErrors>')) {
    nextXml = nextXml.replace('<ignoredErrors>', `${pageLayoutMarkup}<ignoredErrors>`)
  } else {
    nextXml = nextXml.replace('</worksheet>', `${pageLayoutMarkup}</worksheet>`)
  }

  return nextXml
}

function ensureContentTypeEntries(contentTypesXml, drawingPartNames) {
  let nextXml = contentTypesXml

  if (!nextXml.includes('Extension="png"')) {
    nextXml = nextXml.replace(
      '<Default Extension="xml" ContentType="application/xml"/>',
      '<Default Extension="xml" ContentType="application/xml"/><Default Extension="png" ContentType="image/png"/>'
    )
  }

  for (const drawingPartName of drawingPartNames) {
    if (nextXml.includes(`PartName="${drawingPartName}"`)) {
      continue
    }

    nextXml = nextXml.replace(
      '</Types>',
      `<Override PartName="${drawingPartName}" ContentType="application/vnd.openxmlformats-officedocument.drawing+xml"/></Types>`
    )
  }

  return nextXml
}

function ensureWorkbookPrintAreas(workbookXml) {
  const printAreaNames = [
    `<definedName name="_xlnm.Print_Area" localSheetId="0">${COVER_PRINT_AREA}</definedName>`,
    `<definedName name="_xlnm.Print_Area" localSheetId="1">${PRICING_PRINT_AREA}</definedName>`,
    `<definedName name="_xlnm.Print_Area" localSheetId="2">${EXCLUSIONS_PRINT_AREA}</definedName>`
  ]
  const cleanedXml = workbookXml.replace(/<definedName name="_xlnm\.Print_Area"[^>]*>[\s\S]*?<\/definedName>/g, '')

  if (cleanedXml.includes('<definedNames>')) {
    return cleanedXml.replace('</definedNames>', `${printAreaNames.join('')}</definedNames>`)
  }

  return cleanedXml.replace('</workbook>', `<definedNames>${printAreaNames.join('')}</definedNames></workbook>`)
}

function ensureWorkbookCalculationSettings(workbookXml) {
  const workbookWithPrintAreas = ensureWorkbookPrintAreas(workbookXml)
  if (workbookWithPrintAreas.includes('<calcPr ')) {
    return workbookWithPrintAreas.replace(/<calcPr\b[^>]*\/>/, '<calcPr calcId="124519" fullCalcOnLoad="1"/>')
  }

  return workbookWithPrintAreas.replace('</workbook>', '<calcPr calcId="124519" fullCalcOnLoad="1"/></workbook>')
}

function applyPerimeterStyles(sheetXml, startColumnIndex, endColumnIndex, startRowNumber, endRowNumber) {
  let nextXml = sheetXml

  for (let columnIndex = startColumnIndex; columnIndex <= endColumnIndex; columnIndex += 1) {
    const columnName = String.fromCharCode(65 + columnIndex)
    const topCell = `${columnName}${startRowNumber}`
    const bottomCell = `${columnName}${endRowNumber}`
    const topStyleIndex = columnIndex === startColumnIndex
      ? 7
      : (columnIndex === endColumnIndex ? 8 : 5)
    const bottomStyleIndex = columnIndex === startColumnIndex
      ? 9
      : (columnIndex === endColumnIndex ? 10 : 6)
    nextXml = addOrReplaceStyleAttribute(nextXml, topCell, topStyleIndex)
    nextXml = addOrReplaceStyleAttribute(nextXml, bottomCell, bottomStyleIndex)
  }

  for (let rowNumber = startRowNumber + 1; rowNumber < endRowNumber; rowNumber += 1) {
    const leftCell = `${String.fromCharCode(65 + startColumnIndex)}${rowNumber}`
    const rightCell = `${String.fromCharCode(65 + endColumnIndex)}${rowNumber}`
    nextXml = addOrReplaceStyleAttribute(nextXml, leftCell, 3)
    nextXml = addOrReplaceStyleAttribute(nextXml, rightCell, 4)
  }

  return nextXml
}

function buildDrawingXml({ columnIndex, widthEmu, heightEmu }) {
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<wsDr xmlns="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing">
  <oneCellAnchor>
    <from>
      <col>${columnIndex}</col>
      <colOff>0</colOff>
      <row>0</row>
      <rowOff>${LOGO_TOP_OFFSET_EMU}</rowOff>
    </from>
    <ext cx="${widthEmu}" cy="${heightEmu}"/>
    <pic>
      <nvPicPr>
        <cNvPr id="1" name="Image 1" descr="HBFA logo"/>
        <cNvPicPr/>
      </nvPicPr>
      <blipFill>
        <a:blip xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" cstate="print" r:embed="rId1"/>
        <a:stretch xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
          <a:fillRect/>
        </a:stretch>
      </blipFill>
      <spPr>
        <a:prstGeom xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" prst="rect"/>
      </spPr>
    </pic>
    <clientData/>
  </oneCellAnchor>
</wsDr>`
}

function buildDrawingRelationshipXml() {
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  <Relationship Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="/xl/media/image1.png" Id="rId1"/>
</Relationships>`
}

function buildSheetDrawingRelationshipXml(drawingNumber) {
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  <Relationship Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="/xl/drawings/drawing${drawingNumber}.xml" Id="rId1"/>
</Relationships>`
}

export function buildPlanBasedSbfWorkbookFileData(workbook, options = {}) {
  const workbookBytes = XLSX.write(workbook, { type: 'array', bookType: 'xlsx', compression: false })
  const entryMap = new Map(readStoredZipEntries(workbookBytes).map((entry) => [entry.name, entry.data]))

  setXmlEntry(entryMap, 'xl/styles.xml', PROCUREMENT_BRANDED_STYLES_XML)
  setXmlEntry(entryMap, 'xl/workbook.xml', ensureWorkbookCalculationSettings(xmlDecoder.decode(entryMap.get('xl/workbook.xml'))))

  const pricingSheetPath = 'xl/worksheets/sheet2.xml'
  const coverSheetPath = 'xl/worksheets/sheet1.xml'
  const exclusionsSheetPath = 'xl/worksheets/sheet3.xml'
  const pricingValidationMarkup = buildPricingValidationMarkup()
  const drawingMarkup = '<drawing xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" r:id="rId1"/>'

  let pricingSheetXml = ensureSheetPrintSettings(xmlDecoder.decode(entryMap.get(pricingSheetPath)))
  pricingSheetXml = applyPerimeterStyles(pricingSheetXml, 0, 12, 1, PRICING_LAST_DATA_ROW)
  for (let columnIndex = 0; columnIndex < 13; columnIndex += 1) {
    const cellRef = `${String.fromCharCode(65 + columnIndex)}${PRICING_TOTAL_ROW}`
    const styleIndex = (cellRef === `${PRICING_TOTAL_LABEL_COLUMN}${PRICING_TOTAL_ROW}` || cellRef === `${PRICING_TOTAL_COLUMN}${PRICING_TOTAL_ROW}`) ? 2 : 1
    pricingSheetXml = addOrReplaceStyleAttribute(pricingSheetXml, cellRef, styleIndex)
  }
  pricingSheetXml = addOrReplaceStyleAttribute(pricingSheetXml, `A${PRICING_TOTAL_ROW}`, 11)
  pricingSheetXml = addOrReplaceStyleAttribute(pricingSheetXml, `M${PRICING_TOTAL_ROW}`, 12)
  pricingSheetXml = pricingSheetXml.includes('<dataValidations ')
    ? pricingSheetXml.replace(/<dataValidations[\s\S]*?<\/dataValidations>/, pricingValidationMarkup)
    : insertBeforeFirstAnchor(pricingSheetXml, pricingValidationMarkup, [
      '<pageMargins ',
      '<pageSetup ',
      '<ignoredErrors>',
      '<drawing '
    ])
  if (options.logoPngBytes) {
    pricingSheetXml = insertBeforeWorksheetClose(pricingSheetXml, drawingMarkup)
  }
  setXmlEntry(entryMap, pricingSheetPath, pricingSheetXml)

  if (options.logoPngBytes) {
    let coverSheetXml = ensureSheetPrintSettings(xmlDecoder.decode(entryMap.get(coverSheetPath)))
    coverSheetXml = applyPerimeterStyles(coverSheetXml, 0, 5, 1, 30)
    coverSheetXml = insertBeforeWorksheetClose(coverSheetXml, drawingMarkup)
    setXmlEntry(entryMap, coverSheetPath, coverSheetXml)
    let exclusionsSheetXml = ensureSheetPrintSettings(xmlDecoder.decode(entryMap.get(exclusionsSheetPath)))
    exclusionsSheetXml = applyPerimeterStyles(exclusionsSheetXml, 0, 1, 1, 30)
    setXmlEntry(entryMap, exclusionsSheetPath, exclusionsSheetXml)
    entryMap.set('xl/media/image1.png', new Uint8Array(options.logoPngBytes))
    setXmlEntry(entryMap, 'xl/drawings/drawing1.xml', buildDrawingXml({
      columnIndex: 4,
      widthEmu: COVER_LOGO_WIDTH_EMU,
      heightEmu: COVER_LOGO_HEIGHT_EMU
    }))
    setXmlEntry(entryMap, 'xl/drawings/_rels/drawing1.xml.rels', buildDrawingRelationshipXml())
    setXmlEntry(entryMap, 'xl/drawings/drawing2.xml', buildDrawingXml({
      columnIndex: 7,
      widthEmu: PRICING_LOGO_WIDTH_EMU,
      heightEmu: PRICING_LOGO_HEIGHT_EMU
    }))
    setXmlEntry(entryMap, 'xl/drawings/_rels/drawing2.xml.rels', buildDrawingRelationshipXml())
    setXmlEntry(entryMap, 'xl/worksheets/_rels/sheet1.xml.rels', buildSheetDrawingRelationshipXml(1))
    setXmlEntry(entryMap, 'xl/worksheets/_rels/sheet2.xml.rels', buildSheetDrawingRelationshipXml(2))
    if (entryMap.has('[Content_Types].xml')) {
      const contentTypesXml = xmlDecoder.decode(entryMap.get('[Content_Types].xml'))
      setXmlEntry(
        entryMap,
        '[Content_Types].xml',
        ensureContentTypeEntries(contentTypesXml, ['/xl/drawings/drawing1.xml', '/xl/drawings/drawing2.xml'])
      )
    }
  } else {
    let coverSheetXml = ensureSheetPrintSettings(xmlDecoder.decode(entryMap.get(coverSheetPath)))
    coverSheetXml = applyPerimeterStyles(coverSheetXml, 0, 5, 1, 30)
    setXmlEntry(entryMap, coverSheetPath, coverSheetXml)
    let exclusionsSheetXml = ensureSheetPrintSettings(xmlDecoder.decode(entryMap.get(exclusionsSheetPath)))
    exclusionsSheetXml = applyPerimeterStyles(exclusionsSheetXml, 0, 1, 1, 30)
    setXmlEntry(entryMap, exclusionsSheetPath, exclusionsSheetXml)
  }

  return writeStoredZipEntries(Array.from(entryMap.entries()).map(([name, data]) => ({ name, data })))
}



